import { addYears, startOfYear as startOfYear$1, startOfMonth as startOfMonth$1, endOfMonth as endOfMonth$1, startOfWeek as startOfWeek$1, endOfWeek as endOfWeek$1, eachDayOfInterval as eachDayOfInterval$1, eachWeekOfInterval as eachWeekOfInterval$1, isBefore, isSameYear, isAfter, isSameDay } from 'date-fns';

/**
 * Some date-fns functions don't keep the current time of the dates, so we apply it manually
 * This is to support timezone differences
 */
var transformDateWithOriginalTime = function transformDateWithOriginalTime(options) {
  var originalDate = options.originalDate,
    newDate = options.newDate;
  newDate.setHours(originalDate.getHours());
  newDate.setMinutes(originalDate.getMinutes());
  newDate.setSeconds(originalDate.getSeconds());
  newDate.setMilliseconds(originalDate.getMilliseconds());
  return newDate;
};
function startOfYear(options) {
  var date = options.date;
  var newDate = startOfYear$1(date);
  return transformDateWithOriginalTime({
    originalDate: date,
    newDate: newDate
  });
}
function startOfMonth(options) {
  var date = options.date;
  var newDate = startOfMonth$1(date);
  return transformDateWithOriginalTime({
    originalDate: date,
    newDate: newDate
  });
}
function endOfMonth(options) {
  var date = options.date;
  var newDate = endOfMonth$1(date);
  return transformDateWithOriginalTime({
    originalDate: date,
    newDate: newDate
  });
}
function startOfWeek(options) {
  var date = options.date,
    weekStartsOn = options.weekStartsOn;
  var newDate = startOfWeek$1(date, {
    weekStartsOn: weekStartsOn
  });
  return transformDateWithOriginalTime({
    originalDate: date,
    newDate: newDate
  });
}
function endOfWeek(options) {
  var date = options.date,
    weekStartsOn = options.weekStartsOn;
  var newDate = endOfWeek$1(date, {
    weekStartsOn: weekStartsOn
  });
  return transformDateWithOriginalTime({
    originalDate: date,
    newDate: newDate
  });
}
function eachDayOfInterval(options) {
  var start = options.start,
    end = options.end;
  return eachDayOfInterval$1({
    start: start,
    end: end
  }).map(function (date) {
    var nextDate = new Date(date);
    nextDate.setHours(start.getHours());
    nextDate.setMinutes(start.getMinutes());
    nextDate.setSeconds(start.getSeconds());
    nextDate.setMilliseconds(start.getMilliseconds());
    return nextDate;
  });
}
function eachWeekOfInterval(options) {
  var start = options.start,
    end = options.end,
    weekStartsOn = options.weekStartsOn;
  return eachWeekOfInterval$1({
    start: start,
    end: end
  }, {
    weekStartsOn: weekStartsOn
  }).map(function (date) {
    var nextDate = new Date(date);
    nextDate.setHours(start.getHours());
    nextDate.setMinutes(start.getMinutes());
    nextDate.setSeconds(start.getSeconds());
    nextDate.setMilliseconds(start.getMilliseconds());
    return nextDate;
  });
}
function deriveDays(options) {
  var date = options.date,
    weekStartsOn = options.weekStartsOn;
  return eachDayOfInterval({
    start: startOfWeek({
      date: date,
      weekStartsOn: weekStartsOn
    }),
    end: endOfWeek({
      date: date,
      weekStartsOn: weekStartsOn
    })
  });
}
function deriveWeeks(options) {
  var date = options.date,
    weekStartsOn = options.weekStartsOn;
  return eachWeekOfInterval({
    start: startOfMonth({
      date: date
    }),
    end: endOfMonth({
      date: date
    }),
    weekStartsOn: weekStartsOn
  });
}
function deriveYears(options) {
  var date = options.date,
    total = options.total;
  var pastDate = addYears(startOfYear({
    date: date
  }), -total);
  return Array.from(new Array(total * 2), function (_, offset) {
    return addYears(startOfYear({
      date: pastDate
    }), offset);
  });
}
function getWeekdays(options) {
  var date = options.date,
    weekStartsOn = options.weekStartsOn;
  return eachDayOfInterval({
    start: startOfWeek({
      date: date,
      weekStartsOn: weekStartsOn
    }),
    end: endOfWeek({
      date: date,
      weekStartsOn: weekStartsOn
    })
  });
}
function isYearDisabled(options) {
  var date = options.date,
    min = options.min,
    max = options.max;
  if (min && isBefore(date, min) && !isSameYear(date, min)) {
    return true;
  }
  if (max && isAfter(date, max) && !isSameYear(date, max)) {
    return true;
  }
  return false;
}
function isDateDisabled(options) {
  var date = options.date,
    min = options.min,
    max = options.max;
  if (min && isBefore(date, min) && !isSameDay(date, min)) {
    return true;
  }
  if (max && isAfter(date, max) && !isSameDay(date, max)) {
    return true;
  }
  return false;
}

export { deriveDays, deriveWeeks, deriveYears, eachDayOfInterval, eachWeekOfInterval, endOfMonth, endOfWeek, getWeekdays, isDateDisabled, isYearDisabled, startOfMonth, startOfWeek, startOfYear };
